import React from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkMathPlugin from 'remark-math';
import RehypeKatexPlugin from 'rehype-katex';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import python from 'react-syntax-highlighter/dist/esm/languages/hljs/python';
import r from 'react-syntax-highlighter/dist/esm/languages/hljs/r';
import julia from 'react-syntax-highlighter/dist/esm/languages/hljs/julia';
import clsx from 'clsx';
import 'katex/dist/katex.min.css';

SyntaxHighlighter.registerLanguage('python', python);
SyntaxHighlighter.registerLanguage('r', r);
SyntaxHighlighter.registerLanguage('julia', julia);

const useStyles = makeStyles(theme => ({
  markdown: {
    '& h1, h2, h3, h4, h5, h6': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      fontWeight: theme.typography.fontWeightBold,
    },
    '& code': {
      fontSize: '0.8rem',
    },
  },
}));

type MarkdownProps = {
  source: string;
  className?: string;
  codeStyle?: any;
};

export const Markdown: React.FC<MarkdownProps> = ({
  className,
  source,
  codeStyle,
}) => {
  const classes = useStyles({});

  return (
    <React.Fragment>
      <ReactMarkdown
        className={clsx(classes.markdown, className)}
        remarkPlugins={[RemarkMathPlugin]}
        rehypePlugins={[RehypeKatexPlugin]}
        components={{
          code: props => {
            const { children, className, node, ref, ...rest } = props;
            const match = /language-(\w+)/.exec(className || '');
            return match ? (
              <SyntaxHighlighter
                {...rest}
                ref={ref as any}
                PreTag="div"
                language={match[1]}
                style={codeStyle}
              >
                {children as string}
              </SyntaxHighlighter>
            ) : (
              <code {...rest} className={className}>
                {children}
              </code>
            );
          },
        }}
      >
        {source}
      </ReactMarkdown>
    </React.Fragment>
  );
};
